import {
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Card,
  Button,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import {
  Email,
  Face,
  Lock,
  TextFields,
  VisibilityOffOutlined,
  VisibilityOutlined,
  VpnKey,
} from "@material-ui/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import PolicyModal from "../MetaForms/PolicyModal";
import * as ROUTES from "../../constants/routes";
import LangSelect from "../Navigation/LangSelect";
import { withFirebase } from "../Firebase";

const psVInitialState = {
  ps1: false,
  ps2: false,
};

const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function FormBody(props) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { firebase, createRescuer } = props;

  const [policityOpen, setPolicityOpen] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [psw2focused, setPsw2focused] = useState(false);
  const [formError, setFormError] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(psVInitialState);
  const [isSigningUp, setIsSigningUp] = useState(false);

  const checkNotNull = (value, field) => {
    var aux = formError;
    value = value.trim();
    aux[field] = value == "" ? t("notEmptyField") : null;
    updateformError(aux);
  };

  const checkEmail = (email) => {
    var aux = formError;
    const rege = new RegExp(emailPattern);
    if (email == "") {
      checkNotNull(email, "email");
    } else {
      aux["email"] = !rege.test(email) ? t("invalidFormt") : null;
    }
  };

  const checkPassword = (pw1, pw2) => {
    var aux = formError;
    if (pw1.length < 6) {
      aux["psw"] = t("lengthlessthan6");
    } else if (pw2 !== pw1 && psw2focused) {
      aux["psw"] = t("passwordNoMatch");
      aux["psw2"] = t("passwordNoMatch");
    } else {
      aux["psw"] = null;
      aux["psw2"] = null;
    }
    updateformError(aux);
  };

  const updateformError = (aux) => {
    var elem = {};
    Object.keys(aux).forEach((k) => (elem[k] = aux[k]));
    setFormError(elem);
  };

  const checkDataAndCreate = () => {
    var aux = formError;
    setIsSigningUp(true);
    firebase
      .RDNUsersFormsRef("4975998904830969489")
      .once("value")
      .then((snap) => {
        const d = snap.val();
        aux["email"] =
          d.email == email
            ? null
            : "El email tiene que ser el mismo que en RDN";
        updateformError(aux);
        Object.keys(formError).every((k) => formError[k] === null)
          ? createRescuer({
              email: email,
              psw: pass1,
              name: name,
              surname: surname,
            })
          : setIsSigningUp(false);
      });
  };

  const isValid =
    name !== "" &&
    surname !== "" &&
    email !== "" &&
    pass1 !== "" &&
    pass1 === pass2 &&
    Object.keys(formError).every((k) => formError[k] === null);

  return (
    <Grid container item xs={12} spacing={4} justify="center">
      <Card style={{ padding: 24, borderRadius: 16 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              style={{ fontWeight: 700, fontSize: 24, marginBottom: 12 }}
              color="primary"
            >
              Bienvenido al registro de Cardio protección
            </Typography>
            <Typography variant="h6" color="textSecondary">
              Completa el formulario para crear una cuenta
              <Typography variant="body2">{t("fieldsRequired")}</Typography>
            </Typography>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} container justify="space-between">
              <Typography variant="h6" color="textSecondary">
                {t("personalFields")}
              </Typography>
              <Typography>
                {t("selectLang")} <LangSelect />
              </Typography>
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                id="name"
                variant="outlined"
                name="name"
                value={name}
                disabled={isSigningUp}
                onBlur={() => {
                  setName(name.trim());
                  checkNotNull(name, "name");
                }}
                helperText={formError.name}
                error={!!formError.name}
                onChange={(e) => {
                  e = e.target.value;
                  setName(e);
                  !!formError.name && checkNotNull(e, "name");
                }}
                type="text"
                required
                label={t("name")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Face color={!!formError.name ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <TextField
                id="surname1"
                variant="outlined"
                name="surname"
                value={surname}
                disabled={isSigningUp}
                onBlur={() => {
                  setSurname(surname.trim());
                  checkNotNull(surname, "surname");
                }}
                helperText={formError.surname}
                error={!!formError.surname}
                onChange={(e) => {
                  e = e.target.value;
                  setSurname(e);
                  !!formError.surname && checkNotNull(e, "surname");
                }}
                type="text"
                required
                label={t("ape1")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TextFields
                        color={!!formError.surname ? "error" : "primary"}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>

          <Grid item container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="textSecondary">
                {t("reanibexAccount")}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="email"
                variant="outlined"
                name="email"
                disabled={isSigningUp}
                value={email}
                helperText={formError.email}
                error={!!formError.email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  !!formError.email && checkEmail(e.target.value);
                }}
                onBlur={() => checkEmail(email)}
                type="email"
                required
                label={t("email")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email color={!!formError.email ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                required
                id="password"
                variant="outlined"
                name="password1"
                value={pass1}
                disabled={isSigningUp}
                helperText={formError.psw}
                error={!!formError.psw}
                onChange={(e) => {
                  e = e.target.value;
                  setPass1(e);
                  !!formError.psw && checkPassword(e, pass2);
                }}
                onBlur={() => checkPassword(pass1, pass2)}
                type={passwordVisible.ps1 ? "text" : "password"}
                label={t("password")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock color={!!formError.psw ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() => {
                          setPasswordVisible({
                            ...passwordVisible,
                            ps1: !passwordVisible.ps1,
                          });
                        }}
                      >
                        {passwordVisible.ps1 ? (
                          <VisibilityOffOutlined color="primary" />
                        ) : (
                          <VisibilityOutlined />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                id="password2"
                variant="outlined"
                name="password2"
                disabled={isSigningUp}
                value={pass2}
                helperText={formError.psw2}
                error={!!formError.psw2}
                onChange={(e) => {
                  e = e.target.value;
                  setPass2(e);
                  !!formError.psw2 && checkPassword(pass1, e);
                }}
                onBlur={() => checkPassword(pass1, pass2)}
                onFocus={() => {
                  setPsw2focused(true);
                }}
                type={passwordVisible.ps2 ? "text" : "password"}
                label={t("repeatPassword")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock color={!!formError.psw2 ? "error" : "primary"} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() => {
                          setPasswordVisible({
                            ...passwordVisible,
                            ps2: !passwordVisible.ps2,
                          });
                        }}
                      >
                        {passwordVisible.ps2 ? (
                          <VisibilityOffOutlined color="primary" />
                        ) : (
                          <VisibilityOutlined />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container justify="center">
            <Link
              href="#"
              onClick={() => setPolicityOpen(true)}
              variant="body2"
            >
              {t("confPolicity")}
            </Link>
            <Grid container justify="center">
              <Grid item xs={12} md={8} lg={6}>
                <Typography
                  style={{ textAlign: "center", fontSize: 12, marginTop: 6 }}
                  variant="body2"
                  color="textSecondary"
                >
                  {t("policyAcept")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <Grid
        item
        xs={6}
        container
        justify="flex-start"
        style={{ paddingLeft: 0 }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{
            borderRadius: 16,
            height: 48,
            textTransform: "none",
            alignSelf: "flex-start",
          }}
          onClick={() => history.push(ROUTES.SIGN_IN)}
        >
          {t("iGotAccoung")}
        </Button>
      </Grid>
      <Grid
        item
        xs={6}
        container
        justify="flex-end"
        style={{ paddingRight: 0 }}
      >
        <Button
          variant="contained"
          color="primary"
          disabled={!isValid || isSigningUp}
          style={{
            borderRadius: 16,
            height: 48,
            textTransform: "none",
            alignSelf: "flex-end",
          }}
          onClick={checkDataAndCreate}
        >
          {t("createAccount")}
          {isSigningUp && (
            <CircularProgress
              size={24}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: -12,
                marginLeft: -12,
              }}
            />
          )}
        </Button>
      </Grid>
      <PolicyModal open={policityOpen} set={setPolicityOpen} />
    </Grid>
  );
}

export default withFirebase(FormBody);
